import { useState } from "react";
import { CreditCard } from "lucide-react";

export function monthly(amount, months) {
  return Math.ceil((Number(amount) || 0) / months);
}

export default function FinanceHint({ amount, context = "sale", compact = false, testId = "finance-hint" }) {
  const [months, setMonths] = useState(context === "booking" ? 3 : 12);
  const amt = Number(amount) || 0;
  if (amt < 50 || amt > 30000) return null;
  const per = monthly(amt, months);
  if (compact) {
    return <p className="text-[11px] text-slate-400 font-mono" data-testid={testId}>as low as <span className="text-emerald-300 font-semibold">${per.toLocaleString()}/mo</span> · Klarna/Affirm</p>;
  }
  return (
    <div className="flex items-center justify-between gap-3 px-3 py-2 rounded-lg bg-slate-900/70 border border-slate-800" data-testid={testId}>
      <p className="text-xs text-slate-300 flex items-center gap-1.5 flex-wrap">
        <CreditCard className="w-3.5 h-3.5 text-pink-300" />
        As low as <span className="text-emerald-300 font-semibold" data-testid={`${testId}-amount`}>${per.toLocaleString()}/mo</span>
        <span className="text-slate-500">with <span className="text-pink-300">Klarna</span> or <span className="text-sky-300">Affirm</span>{months === 12 ? " · 0% APR" : " · interest-free"}</span>
      </p>
      <select value={months} onChange={(e) => setMonths(Number(e.target.value))} data-testid={`${testId}-months`}
        className="bg-slate-950 border border-slate-800 rounded-md text-xs text-slate-200 px-2 py-1 focus:outline-none focus:border-cyan-500/60">
        {[3, 6, 12].map((m) => <option key={m} value={m}>{`${m} mo`}</option>)}
      </select>
    </div>
  );
}
